import { render, staticRenderFns } from "./ProcessPlate.vue?vue&type=template&id=31380be8&scoped=true&"
import script from "./ProcessPlate.vue?vue&type=script&lang=js&"
export * from "./ProcessPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31380be8",
  null
  
)

export default component.exports